import { IconBag } from '@justeattakeaway/pie-icons-react';
import PIEText from '@src/shared/components/PIEText';
import PIEToggler, {
  PIETogglerSizeEnum,
} from '@src/shared/components/PIEToggler';
import { globalStyles } from 'snacks-design-system';
import React from 'react';
import styles from './OrderDetailItemList.module.scss';
import PIEList from '@src/shared/components/PIEList';
import { useTranslation } from 'react-i18next';
import Scrollbars from 'react-custom-scrollbars';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
const { xdsSpacingB, xdsSpacingD } = globalStyles;
interface componentProps {
  items: Array<any>;
}
export const OrderDetailItemList = ({ items }: componentProps) => {
  const { t } = useTranslation();
  return (
    <PIEComponentUtil marginBottom={xdsSpacingD}>
      <PIEToggler
        isOpen={false}
        size={PIETogglerSizeEnum.WIDE}
        qaSelector="order-detail-item-list-toggler"
        modPanelPadding={false}
        modTogglePadding={true}
        label={
          <PIEText
            text={
              <>
                <IconBag
                  className={styles.OrderDetailItemsTogglerIcon}
                  size="m"
                />
                {t('order.order_detail_items_title')}
              </>
            }
            size="var(--xds-font-size-16)"
            fontWeight="var(--xds-font-weight-bold)"
            color="var(--xds-color-content-default)"
          />
        }
      >
        <PIEComponentUtil marginTop={xdsSpacingB}>
          <div className={styles.OrderDetailItemsListContainer}>
            <Scrollbars
              hideTracksWhenNotNeeded={true}
              autoHeightMax={155}
              autoHeight
              autoHideTimeout={500}
              autoHideDuration={200}
            >
              <PIEList modBorder={false} modCompact={false}>
                {items.map((item, index) => (
                  <PIEList.Item
                    modSectionDivider={false}
                    key={index}
                    left={
                      <PIEText
                        text={item.quantity}
                        size="var(--xds-font-size-16)"
                        fontWeight="var(--xds-font-weight-bold)"
                        color="var(--xds-color-content-default)"
                        align="left"
                      />
                    }
                    secondaryLabel={item.comment}
                  >
                    <PIEText
                      text={item.name}
                      size="var(--xds-font-size-16)"
                      fontWeight="var(--xds-font-weight-bold)"
                      color="var(--xds-color-content-default)"
                    />
                  </PIEList.Item>
                ))}
              </PIEList>
            </Scrollbars>
          </div>
        </PIEComponentUtil>
      </PIEToggler>
    </PIEComponentUtil>
  );
};

export default OrderDetailItemList;
